import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/onquadrature.pdf'; 
import { Helmet } from 'react-helmet';
import OnQuadrature1 from '../images/onquad1.png';
import OnQuadrature2 from '../images/onquad2.png';
import OnQuadrature3 from '../images/onquad3.png';
import OnQuadrature4 from '../images/onquad4.png';
import OnQuadrature5 from '../images/onquad5.png';

function OnQuadrature() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>      
       Source:<br /><br />
		Manuscript held by G. W. Leibniz Bibliothek, Hanover<br />
		Shelfmark LH 35, 2, 1 Bl. 225-226<br /><br />
		{isMobile ? '' : <hr className="centered-hr" />}
		Date: 1681(?)<br /><br />
		Translated from the French<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
		<Link to={pdf} target="_blank">View this translation in PDF format (345k)</Link><br /><br />
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>On Quadrature</title>
            <meta name="description" content="An English translation of ON QUADRATURE by Gottfried Wilhelm Leibniz, from 1681 (?)" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}<br></br>
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <td className="pdf-container">
                    <h2 className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: ON QUADRATURE</h2>
                    {isMobile ? renderLinks() : ''}
                    {isMobile ? <><img src={OnQuadrature1} width="100%"/> <img src={OnQuadrature2} width="100%"/> <img src={OnQuadrature3} width="100%"/> <img src={OnQuadrature4} width="100%"/> <img src={OnQuadrature5} width="100%"/></>: <embed src={pdf} className="responsive-embed"/>}
		              </td>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default OnQuadrature;